import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { splitAroundCount } from './CountEmphasis.utils';
export const GetCountEmphasisTID = (parentTestId)=>getTestIds(parentTestId);
export const CountEmphasis = (param)=>{
    let { text, count, testId } = param;
    const { CountEmphasisTestIds } = useMemo(()=>GetCountEmphasisTID(testId), [
        testId
    ]);
    const [before, emphasised, after] = splitAroundCount(text, count);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            before,
            /*#__PURE__*/ _jsx(Typography, {
                as: "span",
                weight: "normal",
                testId: CountEmphasisTestIds.Count(),
                children: emphasised
            }),
            after
        ]
    });
};
